import React from 'react';
import { Section, Title, Entry } from '../Section';
import styles from '../Resume.module.scss';

export const Education = ({ ...props }) => {
    return (
        <Section {...props}>
            <Entry>
                <Title>Education</Title>
                <EducationEntry
                    date='Sep 2015 – Jun 2020'
                    degree='Bachelor’s Degree in Computer Science'
                    institute='Yıldız Technical University'
                    location='Istanbul, Turkey'
                />
                <EducationEntry
                    date='Feb 2019 – Jun 2019'
                    degree='Erasmus+ Exchange Program'
                    institute='Częstochowa University of Technology'
                    location='Częstochowa, Poland'
                />
            </Entry>
        </Section>
    );
};

const EducationEntry = ({ degree, institute, date, location, department }) => {
    return (
        <Entry>
            <div>
                <div className={styles.sectionEntryHeader}>
                    <b>{degree}</b>
                    <div className={styles.sectionEntryHeaderDate}>{date}</div>
                </div>
                <i>{institute}</i>
                <span>, {location}</span>
                {department && (
                    <div>
                        <i>{department}</i>
                    </div>
                )}
            </div>
        </Entry>
    );
};
